export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpen');
    },
    closeForm({commit}) {
        commit('setFormClose');
    },
    openMergingPatientGrid({commit}) {
        commit('setMergingPatientGridOpen');
    },
    closeMergingPatientGrid({commit}) {
        commit('setMergingPatientGridClose');
    }
}
